
import React from 'react';

const Footer = () => {
  return (
    <footer style={{ marginTop: '10px', backgroundColor: '#29ffff', color: 'black' }}>
      <div style={{  textAlign: 'center', backgroundColor: '#29ffff', padding: '10px', color: 'black' }}>
      <p>This Web Application Project is created by Team Proximity - Students of Vellore Institute of Technology- Bhopal. It utilizes advanced deep learning and machine learning techniques for precise text conversion. Additionally, it integrates 
        Bundeli text-to-audio, enhancing accessibility and cultural immersion in communication </p> 
        </div>
        <div>
        <h3 style={{ fontSize:'16px',padding:'5px'}}>Application Developer</h3>
           <ol>
            <h4 style={{fontSize:'15px'}}>Narendra Kumar Patel</h4>
            <h4 style={{fontSize:'15px'}}>Ashish Kushwaha</h4>
           </ol>
           
           <h3 style={{padding:'5px' ,fontSize:'16px'}}>Words for Language Contributer</h3>
           <p style={{fontSize:'15px' ,padding:'3px'}}>We express profound gratitude to those who contributed Bundelkhandi words, enriching our project journey. Your valuable input has added cultural depth and authenticity, enhancing the overall experience.</p>

        </div>
        
          <div style={{textAlign:'center', fontSize:'20px', padding:'10px'}}> &copy; 2023 @Proximity </div>  
    </footer>
  );
};

export default Footer;